/**
 * Centralized browser storage key registry.
 * App-owned keys are prefixed with "hyperamm:" to avoid conflicts with other apps.
 * Add new keys here — never inline string literals in components.
 */
export const STORAGE_KEYS = {
  /** Theme preference: "light", "dark", or "system" */
  THEME: "hyperamm:theme",

  /** Slippage setting on the Swap page */
  SWAP_SLIPPAGE: "hyperamm:swap:slippage",
  SWAP_CUSTOM_SLIPPAGE: "hyperamm:swap:customSlippage",

  /** Slippage setting on the Liquidity (Deposit/Withdraw) form */
  LIQUIDITY_SLIPPAGE: "hyperamm:liquidity:slippage",
  LIQUIDITY_CUSTOM_SLIPPAGE: "hyperamm:liquidity:customSlippage",

  /** Allowance approval mode: "strict" (exact amount) or "infinite" (max uint256) */
  ALLOWANCE_MODE: "hyperamm:allowanceMode",

  /** Admin/debug ghost mode state */
  GHOST_MODE: "hyperamm:ghost",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export const SESSION_STORAGE_KEYS = {
  /** Temporary wallet-auth address for preview access */
  WALLET_AUTH_ADDRESS: "hyperamm:walletAuth:address",
  /** Temporary wallet-auth signature for preview access */
  WALLET_AUTH_SIGNATURE: "hyperamm:walletAuth:signature",
  /** Temporary wallet-auth signed message for preview access */
  WALLET_AUTH_MESSAGE: "hyperamm:walletAuth:message",
} as const;

export type SessionStorageKey =
  (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS];
